import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Button,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useSpring, animated } from "@react-spring/web";
// import HeroImageMobile from "./images/HeroMob.jpg";
import HeroImageMobile from "./images/v4.jpg";

const HeroSection = ({ registrationRef }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isIphoneSE = useMediaQuery(
    "(max-width: 375px) and (max-height: 667px) and (min-width: 320px)"
  );
  const isIphone12ProMax = useMediaQuery(
    "(min-width: 390px) and (max-width: 428px)"
  );
  const isGalaxyNoteOrUltra = useMediaQuery(
    "(min-width: 412px) and (max-width: 550px)"
  );

  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);
  //   const registrationRef = useRef(null);

  const scrollToRegistration = () => {
    if (registrationRef?.current) {
      registrationRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  //   const scrollToRegistration = () => {
  //     if (registrationRef.current) {
  //       registrationRef.current.scrollIntoView({ behavior: "smooth" });
  //     }
  //   };

  const headingSpring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0px)" : "translateY(20px)",
    delay: 500,
    config: { tension: 120, friction: 14 },
  });

  const subHeadingSpring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0px)" : "translateY(20px)",
    delay: 1000,
    config: { tension: 80, friction: 20 },
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const [shake, setShake] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShake(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      ref={sectionRef}
      sx={{
        height: "100vh",
        backgroundColor: "#000",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 3, md: 6 },
        paddingTop: isIphoneSE
          ? "17vh"
          : isIphone12ProMax || isGalaxyNoteOrUltra
          ? "5vh"
          : "8vh",
        position: "relative",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: { xs: "-25%", sm: "-15%", md: "20%" },
          right: { xs: "-30%", sm: "17%", md: "17%" },
          width: { xs: "500px", sm: "600px", md: "700px" },
          height: { xs: "500px", sm: "600px", md: "620px" },
          background:
            "linear-gradient(to top right, #a020f0, rgba(160, 32, 240, 0.6))",
          filter: "blur(100px)",
          borderRadius: "50%",
          opacity: 0.5,
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: { xs: "-20%", sm: "-10%", md: "20%" },
          right: { xs: "-20%", sm: "17%", md: "17%" },
          width: { xs: "400px", sm: "500px", md: "600px" },
          height: { xs: "400px", sm: "500px", md: "500px" },
          background:
            "linear-gradient(to bottom right, #31ff80, #0066ff, #3e008c)",
          filter: "blur(80px)",
          borderRadius: "50%",
          opacity: 0.7,
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 4, md: 6 },
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>
          <animated.div style={headingSpring}>
            <Typography
              variant="h3"
              fontWeight="bold"
              sx={{
                mb: 1,
                fontSize: {
                  xs: "2.8rem",
                  md: "3.3rem",
                },
              }}
            >
              Оптимизируйте бизнес
            </Typography>
          </animated.div>

          <animated.div style={subHeadingSpring}>
            <Typography
              variant="h6"
              sx={{
                mb: 5,
                fontSize: {
                  xs: "1.25rem",
                  md: "1.5rem",
                  lg: "1.8rem",
                },
              }}
            >
              Увеличьте доходы и освободите время: Узнайте как за 30 минут!
            </Typography>
          </animated.div>

          <Button
            variant="contained"
            onClick={scrollToRegistration}
            sx={{
              background:
                "linear-gradient(to right, #bba8e0, #d47ca2, #cc7472)",
              color: "#fff",
              fontSize: "1rem",
              padding: "0.8rem 1.5rem",
              borderRadius: "50px",
              textTransform: "uppercase",
              animation: shake ? "shake 0.3s ease-in-out 3" : "none",
              "&:hover": {
                background:
                  "linear-gradient(to right, #cc7472, #d47ca2, #bba8e0)",
              },
              "@keyframes shake": {
                "0%": { transform: "translateX(0)" },
                "25%": { transform: "translateX(-5px)" },
                "50%": { transform: "translateX(5px)" },
                "75%": { transform: "translateX(-5px)" },
                "100%": { transform: "translateX(0)" },
              },
            }}
          >
            Забронировать Сессию
          </Button>
          <Typography
            variant="body2"
            sx={{
              fontStyle: "italic",
              marginTop: 5,
              color: "#ccc",
              fontSize: {
                xs: "0.9rem",
                md: "1.1rem",
              },
            }}
          >
            «Успех в бизнесе — это не просто финансовые достижения. Это
            уверенность, вдохновение и умение строить своё будущее так, чтобы
            оно приносило и успех, и удовлетворение от каждого пройденного
            этапа.»
            <br />
            <Box
              component="span"
              sx={{
                color: "#888",
                fontSize: {
                  xs: "1rem",
                  md: "1rem",
                },
              }}
            >
              - Владислав Кронин
            </Box>
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={isMobile ? HeroImageMobile : HeroImageMobile}
            alt="Hero"
            sx={{
              width: isMobile ? "200px" : "100%",
              height: isMobile ? "200px" : "550px",
              borderRadius: isMobile ? "20%" : "20%",
              //   borderRadius: isMobile ? "50%" : "50%",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.5)",
              objectFit: "cover",
              margin: isMobile ? "0 auto" : "0",
              "@media (max-width: 375px)": {
                width: "150px",
                height: "150px",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
